import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import MovieCard from '../movie-card/MovieCard';
import './top-ranked-single-list.scss';

const TopRankedSingleList = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiperRef = useRef(null);

    useEffect(() => {
        setLoading(true);
        fetch('/movies-public-api.php?type=topSingle')
            .then(r => r.json())
            .then(d => { if (d.success) setItems(d.content || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const updateNav = s => { setIsBeginning(s.isBeginning); setIsEnd(s.isEnd); };

    if (loading) return <div style={{ padding: '20px 0', color: '#555' }}>Loading...</div>;
    if (!items.length) return null;

    return (
        <div className="top-ranked-list" style={{ position: 'relative' }}>
            {!isBeginning && (
                <button className="top-ranked-list__nav top-ranked-list__nav--prev" onClick={() => swiperRef.current?.slidePrev()}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="top-ranked-list__nav top-ranked-list__nav--next" onClick={() => swiperRef.current?.slideNext()}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor
                spaceBetween={28}
                slidesPerView="auto"
                onSwiper={s => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
            >
                {items.map((item, idx) => (
                    <SwiperSlide key={item.id} className="top-ranked-slide">
                        <div className="top-ranked-slot">
                            <span className="top-ranked-slot__rank">{idx + 1}</span>
                            <MovieCard item={{
                                id: item.id,
                                title: item.title,
                                poster_path: item.posterUrl,
                                backdrop_path: item.thumbnailUrl || item.posterUrl,
                                slug: item.slug,
                                releaseYear: item.releaseYear,
                                duration: item.duration,
                                averageRating: item.averageRating,
                                episodeCount: item.episodeCount,
                                status: item.status,
                                genres: item.genres,
                                description: item.description,
                                country: item.country,
                            }} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default TopRankedSingleList;
